import { css } from 'styled-components';

export const spaceX = (spacing) => css`
	& :not([hidden]) ~ :not([hidden]) {
		--tw-space-x-reverse: 0;
		margin-right: calc(${spacing}px * var(--tw-space-x-reverse));
		margin-left: calc(${spacing}px * calc(1 - var(--tw-space-x-reverse)));
	}
`;

export const spaceY = (spacing) => css`
	& :not([hidden]) ~ :not([hidden]) {
		--tw-space-y-reverse: 0;
		margin-top: calc(${spacing}px * calc(1 - var(--tw-space-y-reverse)));
		margin-bottom: calc(${spacing}px * var(--tw-space-y-reverse));
	}
`;

export const marginX = (spacing) => {
	if (spacing)
		return css`
			margin-left: ${spacing}px;
			margin-right: ${spacing}px;
		`;
	return css`
		margin-left: auto;
		margin-right: auto;
	`;
};

export const marginY = (spacing) => {
	if (spacing)
		return css`
			margin-top: ${spacing}px;
			margin-bottom: ${spacing}px;
		`;
	return css`
		margin-top: auto;
		margin-bottom: auto;
	`;
};
